module.exports = __webpack_public_path__ + "img/AZ_PANTONE_H_COL1.b2f55b10.png";